var _effectorFileName = "/builds/gmini/front-common/src/Explorer/Provider.tsx";
import * as React from 'react';
import { BaseRenderPropsProvider } from "./BaseRenderProps";
import { PendingProvider } from "./PendingContext";
import { jsx as _jsx } from "react/jsx-runtime";
export var Provider = /*#__PURE__*/React.memo(function (_ref) {
  var children = _ref.children,
      onEntityOpen = _ref.onEntityOpen,
      onCreate = _ref.onCreate,
      onCopy = _ref.onCopy,
      onRename = _ref.onRename,
      onMove = _ref.onMove,
      onRemove = _ref.onRemove,
      categoryIcon = _ref.categoryIcon,
      categoryEmptyIcon = _ref.categoryEmptyIcon,
      entityIcon = _ref.entityIcon,
      assemblyIcon = _ref.assemblyIcon,
      selectedProject = _ref.selectedProject;
  return /*#__PURE__*/_jsx(BaseRenderPropsProvider, {
    onEntityOpen: onEntityOpen,
    onCreate: onCreate,
    onCopy: onCopy,
    onRename: onRename,
    onMove: onMove,
    onRemove: onRemove,
    categoryIcon: categoryIcon,
    categoryEmptyIcon: categoryEmptyIcon,
    entityIcon: entityIcon,
    assemblyIcon: assemblyIcon,
    selectedProject: selectedProject,
    children: /*#__PURE__*/_jsx(PendingProvider, {
      children: children
    })
  });
});
Provider.displayName = 'Provider';